"use strict";

require("../../style/index.less");

require("../../grid/style");